import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CheckCircle, ArrowLeft, Plus, Search } from 'lucide-react';
import BottomNav from '../components/BottomNav';

export default function NoMatchScreen() {
  const navigate = useNavigate();
  const location = useLocation();

  const { result, vrn } = location.state || {};

  if (!result) {
    navigate('/', { replace: true });
    return null;
  }

  const handleCheckAnother = () => navigate('/', { replace: true });
  const handleLogSighting = () => navigate('/log-sighting', { state: { vrn: vrn || result.vrn } });

  return (
    <div style={{
      minHeight: '100vh',
      background: '#001a4d',
      display: 'flex',
      flexDirection: 'column',
      fontFamily: "'Inter', sans-serif",
      paddingBottom: '80px',
    }} data-testid="no-match-screen">

      {/* Header */}
      <div style={{
        background: 'rgba(255,255,255,0.06)',
        borderBottom: '1px solid rgba(255,255,255,0.1)',
        padding: '14px 18px',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
      }}>
        <button onClick={handleCheckAnother} style={{
          width: '38px', height: '38px',
          background: 'rgba(255,255,255,0.1)',
          border: 'none', borderRadius: '10px',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          cursor: 'pointer',
        }} data-testid="back-btn">
          <ArrowLeft size={18} color="white" />
        </button>
        <span style={{
          fontFamily: "'Oswald', sans-serif",
          fontSize: '16px', fontWeight: 600,
          color: 'white', letterSpacing: '2px',
          textTransform: 'uppercase',
        }}>Check Result</span>
      </div>

      {/* Body */}
      <div style={{
        flex: 1, display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        padding: '32px 20px',
      }}>

        {/* Plate */}
        <div style={{
          background: '#F5C400', border: '3px solid #111',
          borderRadius: '8px', padding: '12px 28px',
          fontFamily: "'Oswald', sans-serif",
          fontSize: '34px', fontWeight: 700,
          color: '#111', letterSpacing: '7px',
          marginBottom: '24px',
        }} data-testid="result-vrn">
          {vrn || result.vrn}
        </div>

        {/* Green circle */}
        <div style={{
          width: '72px', height: '72px', borderRadius: '50%',
          background: '#15803d',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          marginBottom: '20px',
          boxShadow: '0 0 0 8px rgba(21,128,61,0.15)',
        }} data-testid="status-indicator">
          <CheckCircle size={36} color="white" />
        </div>

        {/* White card */}
        <div style={{
          background: 'white', borderRadius: '16px',
          padding: '24px 20px', width: '100%', maxWidth: '360px',
          boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
          textAlign: 'center',
        }}>
          <div style={{
            fontFamily: "'Oswald', sans-serif",
            fontSize: '22px', fontWeight: 700,
            color: '#001a4d', letterSpacing: '2px',
            textTransform: 'uppercase', marginBottom: '10px',
          }} data-testid="result-heading">No Records Found</div>

          <p style={{
            fontSize: '13px', color: '#7a8aaa',
            lineHeight: 1.7, marginBottom: '20px',
          }} data-testid="result-message">
            This vehicle has no recorded sightings on VCIN. If you have observed suspicious activity, log a sighting to start building the intelligence picture.
          </p>

          {result.known_vehicle && (
            <div style={{ marginBottom: '16px' }} data-testid="known-vehicle-badge">
              <span style={{
                display: 'inline-block',
                background: '#001a4d', color: 'white',
                borderRadius: '20px', padding: '5px 14px',
                fontFamily: "'Oswald', sans-serif",
                fontSize: '11px', fontWeight: 600, letterSpacing: '2px',
              }}>{result.known_vehicle.status}</span>
              {result.known_vehicle.name && (
                <p style={{ fontSize: '12px', color: '#7a8aaa', marginTop: '6px' }}>
                  {result.known_vehicle.name}
                </p>
              )}
            </div>
          )}

          <button onClick={handleLogSighting} style={{
            width: '100%', background: '#001a4d',
            border: 'none', borderRadius: '10px',
            padding: '15px', color: 'white',
            fontFamily: "'Oswald', sans-serif",
            fontSize: '16px', fontWeight: 600,
            letterSpacing: '4px', textTransform: 'uppercase',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            gap: '8px', cursor: 'pointer',
            boxShadow: '0 4px 16px rgba(0,26,77,0.3)',
            marginBottom: '10px',
          }} data-testid="log-sighting-btn">
            <Plus size={18} /><span>Log a Sighting</span>
          </button>

          <button onClick={handleCheckAnother} style={{
            width: '100%', background: 'white',
            border: '2px solid #001a4d', borderRadius: '10px',
            padding: '13px', color: '#001a4d',
            fontFamily: "'Oswald', sans-serif",
            fontSize: '16px', fontWeight: 600,
            letterSpacing: '3px', textTransform: 'uppercase',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            gap: '8px', cursor: 'pointer',
          }} data-testid="check-another-btn">
            <Search size={18} /><span>Check Another</span>
          </button>
        </div>
      </div>

      <BottomNav activeTab="home" />
    </div>
  );
}
